// extracted by mini-css-extract-plugin
module.exports = {"facet":"Facet_facet__s8O_g","count":"Facet_count__qbndr"};